import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const crdColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'crd',
  headerName: 'CRD',
  initialHide: true,
};
